/**
 * SECTION 2C - TASKS JS
 *
 * DATA TO BE STORED IN THE BACKEND FOR THIS:
 * - 
 *
 */
import $ from 'jquery';
import aon_craft_sliders from './aon_craft_sliders.js';
import aon_craft_utils from './aon_craft_utils.js';
window.jQuery = $;

export default {
    init() {
        /*
         * SECTION 2C - Initialise Tasks UI, data
         * UI interaction functions
         */
        console.log( 'SECTION 2C - Tasks widget - init' );
        
        // Variable to contain task entries
        this.aon_section_2c_data = []; 
        
        // Get any existing saved data...
        if ( $( '#business_plan' ).length > 0 ) { // If Business Plan page then load live data...
            this.loadData( 'load_live' );
            
        } else { // If not Business Plan page then we are in 2C...
            if ( $( '#section_2c_data_json' ).val() != '' ) { // If JSON data field is not empty then we presume this is saved data and try to load it...
                this.loadData( 'load_live' );
                
            } else { // If no saved data then we start with a default data structure...
                this.loadData( 'start' ); 
            }
            //this.loadData( 'load_demo' );
        }
        
        // Render Data...
        this.renderData();
        
        /*
         * Add / Edit Modal interaction...
         */
        
        var tasks_add_edit_modal_mode = '';
        
        // Click to Edit existing tasks entry modal link...
        $( 'body' ).on( 'click', '.tasks_entry a', function( event ) {
            tasks_add_edit_modal_mode = 'edit';
            var name = $( this ).text();
            var task_type = $( this ).attr( 'data-tasks-entry-task-type' );
            var id = $( this ).attr( 'data-tasks-entry-id' );
            $( '#tasks_add_edit_entry_modal #tasks_entry_title_field' ).val( name );
            $( '#tasks_add_edit_entry_modal #tasks_entry_task_type' ).val( task_type );
            $( '#tasks_add_edit_entry_modal #tasks_entry_id' ).val( id );
            
            //console.log( 'Start opening Tasks Modal...');
            openTasksModal();
            //console.log( 'Done opening Tasks Modal...');
            
            event.preventDefault();
        });
		
		// Task entry hover / highlighting...
        $( 'body' ).on( 'mouseenter', '.tasks_entry', function() {
			$( this ).find( $( '.task-entry-edit-tooltip' ) ).remove();
			var edit_tooltip = $( '.task-entry-edit-tooltip.hide' ).clone();
			edit_tooltip.removeClass( 'hide' );
			$( this ).append( edit_tooltip );
        });

        $( 'body' ).on( 'mouseleave', '.tasks_entry', function() {
			$( this ).find( $( '.task-entry-edit-tooltip' ) ).remove();
        });
		
        
        var openTasksModal = () => { // Function defined using arrow method to gain access to main 'this'
            // Open specific modal depending on whether we're adding / editing entries or setting activity types
            //console.log( 'Called opening Tasks Modal...');
            $( '#tasks_add_edit_entry_modal' ).foundation( 'open' );
        }
        
        var renderTaskTypes = () => { // Function defined using arrow method to gain access to main 'this'
                //console.log( 'renderTaskTypes - start' );
                // Clear any added slides before generating to avoid duplication / multiplication!
                $( '#tasks_types_slider .task-slide' ).remove();
			
				// If tasks have been assigned a category then we should enable the "Next" button
				const allowedTaskTypes = ['idea', 'production', 'marketing', 'management'];
				let has_task_categories = true;
                
                // Get activities and render to slider...
				// We need to reverse the array first so they get added in the correct order by the `addSlide` function call
				var aon_section_2c_data_reversed_array = this.aon_section_2c_data.reverse();
                //$.each( this.aon_section_2c_data, function( index ) {
                $.each( aon_section_2c_data_reversed_array, function( index ) {
                    //console.log( 'renderTaskTypes - loop' );
                    var tasks_types_slider_entry = '';
                    tasks_types_slider_entry += '<li class="orbit-slide task-slide task-slide-' + index + ' text-center" data-task-entry-id="' + index + '">';
                    tasks_types_slider_entry += '    <div class="row align-center top-margin-zero bottom-margin-zero block_text ' + this.task_type + '">';
                    tasks_types_slider_entry += '      <div class="columns small-12 medium-10">';
                    tasks_types_slider_entry += '          <div class="block flex-container text-center">';
                    tasks_types_slider_entry += '              <h4 class="align-self-middle flex-child-auto">' + this.name + '</h4>';
                    tasks_types_slider_entry += '          </div>';
                    tasks_types_slider_entry += '      </div>';
                    tasks_types_slider_entry += '    </div>';
                    tasks_types_slider_entry += '</li>';
                    //console.log( 'tasks_types_slider_entry: ' + tasks_types_slider_entry); 
                    
                    // Add slide...
                    addSlide( 'tasks_types_slider', tasks_types_slider_entry, '.start-slide' );
                    // We append activity buttons to the new slide by cloning the source element '.tasks-types-buttons-source',
                    // this keeps the markup in the template so that 'income' / 'cost' can be in the correct language string.
                    $( '.tasks-types-buttons-source' ).clone().appendTo( '.task-slide-' + index + ' .columns' ).removeClass( 'tasks-types-buttons-source' ).addClass( 'task-types-buttons' );
					
					if ( !this.task_type || !allowedTaskTypes.includes(this.task_type) ) {
						has_task_categories = false;
						//return false; // breaks out of $.each early
					}
					
                });
			
				if ( has_task_categories === true ) {
					$( '.task_types_next' ).removeClass( 'disabled' );
				}
                
                aon_craft_sliders.sliderInit( 'tasks_types_slider' ); 
                aon_craft_sliders.getActiveSlideNumber( 'tasks_types_slider' ); // Send ID of slider without the '#'
                aon_craft_sliders.sliderChange( 'tasks_types_slider' );
            
                //console.log( 'renderTaskTypes - end' );
        }
        
        function addSlide( a, b, c ) {
            aon_craft_sliders.sliderAddSlide( a, b, c );
        }
        
        var renderTasksOverview = () => { // Function defined using arrow method to gain access to main 'this'
                //console.log( 'renderTasksOverview - start' );
                // Clear any added slides before generating to avoid duplication / multiplication!
                $( '.tasks_category_list ul.menu li' ).remove();
                
                // Get activities and render to slider...
                $.each( this.aon_section_2c_data, function( index ) {
                    //console.log( 'renderTasksOverview - loop' );
                    // Get tasks of each type
                    if ( this.task_type == 'idea' ) {
                        $( '.tasks_category_list li.idea ul.menu' ).append( '<li>' + this.name + '</li>' );
                    }
                    if ( this.task_type == 'production' ) {
                        $( '.tasks_category_list li.production ul.menu' ).append( '<li>' + this.name + '</li>' );
                    }
                    if ( this.task_type == 'marketing' ) {
                        $( '.tasks_category_list li.marketing ul.menu' ).append( '<li>' + this.name + '</li>' );
                    }
                    if ( this.task_type == 'management' ) {
                        $( '.tasks_category_list li.management ul.menu' ).append( '<li>' + this.name + '</li>' );
                    }
                    /*var tasks_types_slider_entry = '';
                    tasks_types_slider_entry += '<li class="orbit-slide task-slide task-slide-' + index + ' text-center" data-task-entry-id="' + index + '">';
                    tasks_types_slider_entry += '    <div class="row align-center top-margin-zero bottom-margin-zero block_text ' + this.task_type + '">';
                    tasks_types_slider_entry += '      <div class="columns small-12 medium-10">';
                    tasks_types_slider_entry += '          <div class="block flex-container text-center">';
                    tasks_types_slider_entry += '              <h4 class="align-self-middle flex-child-auto">' + this.name + '</h4>';
                    tasks_types_slider_entry += '          </div>';
                    tasks_types_slider_entry += '      </div>';
                    tasks_types_slider_entry += '    </div>';
                    tasks_types_slider_entry += '</li>';*/
                    
         
                    // We append activity buttons to the new slide by cloning the source element '.tasks-types-buttons-source',
                    // this keeps the markup in the template so that 'income' / 'cost' can be in the correct language string.
                    //$( '.tasks-types-buttons-source' ).clone().appendTo( '.task-slide-' + index + ' .columns' ).removeClass( 'tasks-types-buttons-source' ).addClass( 'task-types-buttons' );
                });
            
                //console.log( 'renderTasksOverview - end' );
        }
        
        // Click on Activity Type Income / Cost links...
        $( 'body' ).on( 'click', '.tasks-types-buttons a', function( event ) {
            //console.log( 'Clicked on tasks-types-buttons a - START' + $( this ).attr( 'class' ) );
            var c = $( this ).attr( 'class' );
                c = c.replace( 'column', '' ); // Strip off unwantet classes
                c = c.replace( 'flex-container', '' ); // to get only specific targer class
                c = c.replace( 'align-center-middle', '' ); // to get only specific target class
                c = c.replace( 'button', '' ); // to get only specific target class
                c = c.trim();
            //console.log( 'c: ' + c );
            
            if ( c == 'idea' ) {
                var entry_id = $( '.task-slide.is-active' ).attr( 'data-task-entry-id' );
                setTaskType( entry_id, 'idea' );
                $( '.task-slide.is-active .block_text' ).removeClass( 'production marketing management' ).addClass( 'idea' );
                $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                //console.log( 'Clicked on tasks-types-buttons a - idea' );
                
            } else if ( c == 'production' ) {
                var entry_id = $( '.task-slide.is-active' ).attr( 'data-task-entry-id' );
                setTaskType( entry_id, 'production' );
                $( '.task-slide.is-active .block_text' ).removeClass( 'idea marketing management' ).addClass( 'production' );
                $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                //console.log( 'Clicked on tasks-types-buttons a - production' );
                
            } else if ( c == 'marketing' ) {
                var entry_id = $( '.task-slide.is-active' ).attr( 'data-task-entry-id' );
                setTaskType( entry_id, 'marketing' );
                $( '.task-slide.is-active .block_text' ).removeClass( 'idea production management' ).addClass( 'marketing' );
                $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                //console.log( 'Clicked on tasks-types-buttons a - marketing' );
                
            } else if ( c == 'management' ) {
                var entry_id = $( '.task-slide.is-active' ).attr( 'data-task-entry-id' );
                setTaskType( entry_id, 'management' );
                $( '.task-slide.is-active .block_text' ).removeClass( 'idea production marketing' ).addClass( 'management' );
                $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                //console.log( 'Clicked on tasks-types-buttons a - management' );
                
            }
            event.preventDefault();
            
            // Check if all activity slides have cost or income classes applied,
            // if so then enable 'next' button to allow user to proceed...
            var enable_next = false;
            $( '#tasks_types_slider .task-slide' ).each( function( index, element ) {
                if ( $( '.block_text', this ).hasClass( 'idea' ) || $( '.block_text', this ).hasClass( 'production' ) || $( '.block_text', this ).hasClass( 'marketing' ) || $( '.block_text', this ).hasClass( 'management' ) ) {
                    enable_next = true;
                } else {
                    enable_next = false;
                }
            });
            
            if ( enable_next === true ) {
                $( '.task_types_next' ).removeClass( 'disabled' );
            }
            
        });
     
        
        var setTaskType = ( entry_id, task_type ) => {
            //console.log( 'setTaskType: ' + entry_id + ' - ' + task_type );
            this.aon_section_2c_data[ entry_id ][ 'task_type' ] = task_type;
            this.renderTaskEntries();
        }

        // Click on Add Task entry modal link...
        $( 'body' ).on( 'click', '.tasks_entry_add_edit a', function( event ) {
            tasks_add_edit_modal_mode = 'add';
            event.preventDefault();
        });

        // 'Save' button click within Tasks entry modal...
        $( 'body' ).on( 'click', '#save_tasks_entry', function( event ) {
            // Save data to existing
            var id = $( '#tasks_add_edit_entry_modal #tasks_entry_id' ).val();
            var name = aon_craft_utils.removeHTMLTags( $( '#tasks_add_edit_entry_modal #tasks_entry_title_field' ).val() );
            var task_type = aon_craft_utils.removeHTMLTags( $( '#tasks_add_edit_entry_modal #tasks_entry_task_type' ).val() );
            if ( tasks_add_edit_modal_mode == 'edit' ) {
                // Update existing entry to entries array - if req values all complete...
                if ( id != '' && name != '' ) {
                    saveExistingTasksEntry( id, name, task_type );
                }
            } else if ( tasks_add_edit_modal_mode == 'add' ) {
                // Add new entry to entries array - if req values all complete...
                if ( name != '' ) {
                    saveNewTasksEntry( name, task_type );
                }
            } else if ( tasks_add_edit_modal_mode == 'delete' ) {
                // Delete...
                deletingExistingTasksEntry( id );
            }
            
            event.preventDefault();
        });
        
        var saveExistingTasksEntry = ( id, name, task_type ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_2c_data[ id ][ 'name' ] = name;
            this.aon_section_2c_data[ id ][ 'task_type' ] = task_type;
            this.renderTaskEntries();
            $( '#tasks_add_edit_entry_modal' ).foundation( 'close' );
            $( '.tasks_add_edit_next' ).removeClass( 'disabled' );
            //console.log( 'SAVE TASK' );
            renderTaskTypes();
        }
        
        var saveNewTasksEntry = ( name, task_type ) => { // Function defined using arrow method to gain access to main 'this'
            //var new_entry = { name: name, start_month: start_month, duration: duration, activity_type: '' }
            this.aon_section_2c_data.push( { name: name, task_type: task_type } );
            this.renderTaskEntries();
            $( '#tasks_add_edit_entry_modal' ).foundation( 'close' );
            $( '.tasks_add_edit_next' ).removeClass( 'disabled' );
            $( '.tasks_activity_types_next' ).addClass( 'disabled' );
            //renderTaskTypes();
        }
        
        var deletingExistingTasksEntry = ( id ) => { // Function defined using arrow method to gain access to main 'this'
            this.aon_section_2c_data[ id ][ 'name' ] = name;
            this.aon_section_2c_data.splice( id, 1 );
            this.renderTaskEntries();
            $( '#tasks_add_edit_entry_modal' ).foundation( 'close' );
            //$( '.calendar_add_edit_next' ).removeClass( 'disabled' );
            
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_tasks_entry ').text( save_text ); // Save
            $( '#save_tasks_entry ').removeClass( 'delete' );            
            //renderTaskTypes();
        }
        
        
        // Add / Edit Entry modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#tasks_add_edit_entry_modal', function() {
            if ( tasks_add_edit_modal_mode == 'edit' ) {
                $( '.edit', this ).show();
                $( '.add', this ).hide();
                $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_entry ').text( save_text ); // Save
                $( '#save_entry ').removeClass( 'delete' );
                $( '.delete_entry_panel', this ).show();
                
            } else if ( tasks_add_edit_modal_mode == 'add' ) {
                $( '.edit', this ).hide();
                $( '.add', this ).show();
                $( '.delete_entry_panel', this ).hide();
                $( '#entry_title_field' ).val( '' );
                
            }
            $( '#tasks_entry_title_field' ).focus();
            //console.log( 'tasks_add_edit_entry_modal open' );
        });

        // Add / Edit Entry modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#tasks_add_edit_entry_modal', function() {
            $( '#tasks_entry_title_field' ).val( '' );
            $( '#delete_entry' ).prop( 'checked', false ).trigger( 'change' );
			var save_text = $( '.modal_save_text' ).val();
			//var delete_text = $( '.modal_delete_text' ).val();
            $( '#save_tasks_entry ').text( save_text ); // Save
            $( '#save_tasks_entry ').removeClass( 'delete' );
            //console.log( 'tasks_add_edit_entry_modal close' );
        });
        
        // Activity Type modal open event...
        $( 'body' ).on( 'open.zf.reveal', '#tasks_entry_activity_modal', function() {
            //console.log( 'tasks_entry_activity_modal open' );
        });
        
        // Activity Type modal close event...
        $( 'body' ).on( 'closed.zf.reveal', '#tasks_entry_activity_modal', function() {
            $('#tasks_types_slider').foundation( 'changeSlide', true, $( '.start-slide' ), 0 );
            //console.log( 'tasks_entry_activity_modal close' );
        });
        
        
        
        /*
         * Next / Back buttons...
         */
        // 'calendar_activity_types_back' button click...
        /*$( 'body' ).on( 'click', '.calendar_activity_types_back', function( event ) {
            // Switch Calendar to regular 'add_edit_activities' mode...
            switchCalendarMode( 'add_edit_activities' );
            event.preventDefault();
        });*/
        
        // 'tasks_add_edit_next', 'tasks_add_edit_next' button clicks...
        $( 'body' ).on( 'click', '.tasks_add_edit_next, .tasks_overview_back', function( event ) {
            renderTaskTypes();
            event.preventDefault();
        });
        
        // 'tasks_add_edit_next', 'tasks_add_edit_next' button clicks...
        $( 'body' ).on( 'click', '.task_types_next', function( event ) {
            renderTasksOverview();
            event.preventDefault();
        });
        
        
        $( 'body' ).on( 'change', '#delete_entry', function( event ) {
            if ( $( '#delete_entry' ).prop( 'checked' ) ) {
				//var save_text = $( '.modal_save_text' ).val();
				var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_tasks_entry ').text( delete_text ); // DELETE
                $( '#save_tasks_entry ').addClass( 'delete' );
                tasks_add_edit_modal_mode = 'delete';
                //console.log( 'DELETE' );
            } else {
				var save_text = $( '.modal_save_text' ).val();
				//var delete_text = $( '.modal_delete_text' ).val();
            	$( '#save_tasks_entry ').text( save_text ); // Save
                $( '#save_tasks_entry ').removeClass( 'delete' );
                tasks_add_edit_modal_mode = 'edit';
                //console.log( 'NOT DELETE' );
            }
            event.preventDefault();
        });
        
        
        
        
        // Check whether Activity Type has been applied to Activity before allowing 'orbit-next' button action to work...
        $( 'body' ).on( 'slidechange.zf.orbit', '#tasks_types_slider', function( e, handle ) {
            // if active slide has activity type class added then proceed...
            var active_slide = $( '#tasks_types_slider .orbit-slide.is-active ' );
            ////console.log( active_slide );
            
            if ( active_slide.hasClass( 'task-slide' ) && active_slide.not( '.start-slide' ) ) {
                //console.log( 'Not the start!' );
                if ( active_slide.children( '.block_text' ).hasClass( 'idea') ) {
                    //console.log( 'Yep - Idea!');
                    $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                    
                } else if ( active_slide.children( '.block_text' ).hasClass( 'production') ) {
                    //console.log( 'Yep - Production!');
                    $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                    
                } else if ( active_slide.children( '.block_text' ).hasClass( 'marketing') ) {
                    //console.log( 'Yep - Marketing!');
                    $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                    
                } else if ( active_slide.children( '.block_text' ).hasClass( 'management') ) {
                    //console.log( 'Yep - Management!');
                    $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                    
                } else {
                    $( '#tasks_types_slider .orbit-next' ).addClass( 'do_not_proceed' ).attr( 'disabled', 'disabled' );
                    
                }
                
            } else {
                $( '#tasks_types_slider .orbit-next' ).removeClass( 'do_not_proceed' ).removeAttr( 'disabled' );
                
            }
      
        });
        
        
        
        // Click on 'save_data' to submit completed data to backend storage...
        $( 'body' ).on( 'click', '.save_data', ( event ) => {
            this.saveData();
        });
        

    },
    
    renderData() {
        // Render Tasks...
        //console.log( 'renderData - start' );
        
        
        // Get any existing saved Tasks entry data...
        this.loadData();
        
        // Render entries...
        this.renderTaskEntries();
        
        if ( this.aon_section_2c_data === '' ) {
            $( '.tasks_entry_add_edit' ).addClass( 'no_entries' );
        }
    },
    
    renderTaskEntries() {
        /*
         * Load / render existing entries to calendar...
         */
        //console.log( 'renderTaskEntries - start' );
        //console.table( this.aon_section_2c_data );  
        
        // Remove any existing entries so that we don't re-render...
        $( '.tasks_list li.tasks_entry' ).remove();
   
        // Loop over entries array...
        var entry_count = 1;
        $.each( this.aon_section_2c_data, function( index ) {
            // Begin entry...            
            var aon_tasks_entry_link = '<a href="#edit_tasks_entry" data-tasks-entry-id="' + index + '" data-tasks-entry-task-type="' + this.task_type + '" class="entry_' + entry_count + ' ' + this.task_type + '" title="' + this.name + '">' + this.name + '</a>';
            $( '.tasks_list' ).append( '<li class="tasks_entry">' + aon_tasks_entry_link + '</li>' );
            entry_count++;
        });
        
        // If enable / disable Next button depending on whether entries exist...
        //tasks_add_edit_next
        if ( !this.aon_section_2c_data.length ) {
            $( '.tasks_add_edit_next' ).addClass( 'disabled' );
        } else {
            $( '.tasks_add_edit_next' ).removeClass( 'disabled' );
        }

    },

    loadData( mode ) {
        /*
         * Set Data.
         * Either load existing data from backend or set default blank data...
         */
        
        // Load data from backend...
        
        if ( mode == 'load_live' ) {
            // Load from json array in page
            var aon_section_2c_data_json = $( '#section_2c_data_json' ).val();
            this.aon_section_2c_data = JSON.parse( aon_section_2c_data_json );
            $( '.tasks_add_edit_next' ).removeClass( 'disabled' );
            
        } else if ( mode == 'load_demo' ) {
            // Using temp JSON source for now...
            var aon_section_2c_data_json = '[';
                aon_section_2c_data_json += '{"name":"Glow in the dark gloves?","task_type":""},';
                aon_section_2c_data_json += '{"name":"Make some clothes","task_type":""},';
                aon_section_2c_data_json += '{"name":"Send out spam","task_type":""},';
                aon_section_2c_data_json += '{"name":"Manage stuff","task_type":""}';
                aon_section_2c_data_json += ']';

            this.aon_section_2c_data = JSON.parse( aon_section_2c_data_json );
            $( '.tasks_add_edit_next' ).removeClass( 'disabled' );
            
        } else if ( mode == 'start' ) {

            //this.addDataEntry();
            
        }
        
    },
    
    saveData() {
        // Call AJAX request to WP / Rest API
        // Save completed data to backend...
        var jsonDataString = JSON.stringify( this.aon_section_2c_data );
        console.log( 'jsonDataString: ' + jsonDataString );
        
        console.log( '2C AJAX - START' );
        var meta = { 'section_2c_data_one' : jsonDataString };
        $.ajax({
            url: wpApiSettings.root + 'wp/v2/users/' + wpApiSettings.current_user_id,
            method: 'POST',
            beforeSend: function ( xhr ) {
                xhr.setRequestHeader( 'X-WP-Nonce', wpApiSettings.nonce );
            },
            data: {
                'meta' : meta
            }
        }).done( function ( response ) {
            console.log( 'Response: ' );
            console.log( response );
        });
        console.log( '2C AJAX - END' );
        
        console.log( 'Saving data via AJAX, saving the following:' );
        console.table( this.aon_section_2c_data );
    }
}